var link_styles = {
  link_container: {
    display: "flex",
    padding: "4px 0px",
    alignItems: "center",
    gap: "4px",
    // width: "100%"
  },
  link: {
    color: "var(--Black---1000, #191924)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "16px",
    textDecorationLine: "underline" as const,
    textDecorationStyle: "solid" as const,
    textDecorationSkipInk: "auto" as const,
    textDecorationThickness: "auto" as const,
    textUnderlineOffset: "auto" as const,
    textUnderlinePosition: "from-font" as const,
  },
};

export default link_styles;
